import { FC } from 'react'

import FormikField from '../../form/FormikField'
import { FormikFormProps } from '../../form/FormikForm'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { FormSubmitButtonProps } from '../../form/FormSubmitButton'
import FormMessages, { FormMessagesProps } from '../../form/FormMessages'
import FormFieldTextArea, {
  FormFieldTextAreaProps,
} from '../../form/fields/FormFieldTextArea'
import { FormFieldSelectProps } from '../../form/fields/FormFieldSelect'
import FormFieldRadioGroup, {
  FormFieldRadioGroupProps,
} from '../../form/fields/FormFieldRadioGroup'

import * as SC from './styled'

type AdsArchiveFormValues = {
  filled: string
  service: string
  recommended: string
  suggestions: string
}

export type AdsArchiveFormProps = FormikFormProps<AdsArchiveFormValues> & {
  text?: string
  fields: {
    filled: Omit<FormFieldRadioGroupProps, 'name'>
    service: Omit<FormFieldSelectProps, 'name'>
    recommended: Omit<FormFieldRadioGroupProps, 'name'>
    suggestions: Omit<FormFieldTextAreaProps, 'name'>
  }
  errors?: FormMessagesProps['messages']
  submitButton?: FormSubmitButtonProps
}

const AdsArchiveForm: FC<AdsArchiveFormProps> = ({
  fields,
  submitButton,
  errors,
  ...formikProps
}) => {
  const { filled, recommended, service, suggestions } = fields

  return (
    <SC.Container>
      <SC.Form {...formikProps}>
        <SC.Fields>
          <FormFieldRadioGroup
            {...filled}
            labelProps={{ underlined: true }}
            name="filled"
          />
          <FormikField
            {...service}
            labelProps={{ underlined: true }}
            name="service"
            type="text"
            Component={SC.Select}
          />
          <FormFieldRadioGroup
            {...recommended}
            name="recommended"
            labelProps={{ underlined: true }}
          />
          <FormikField
            {...suggestions}
            name="suggestions"
            labelProps={{ underlined: true }}
            size="small"
            Component={FormFieldTextArea}
          />
        </SC.Fields>
        {errors && <FormMessages messages={errors} />}
        <SC.Actions>
          <SC.SubmitButton
            type={'submit'}
            variant={ActionButtonVariant.quaternary}
            {...submitButton}
          />
        </SC.Actions>
      </SC.Form>
    </SC.Container>
  )
}

export default AdsArchiveForm
